import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import styled from '@emotion/styled'
import { OrganisationMetaDetail } from 'api'
import { Groupbox } from 'view/components/panels'
import { AgGridWrapper } from 'view/components/datagrid'
import { ModalConsumerProps, withModal } from 'view/shared/modal'
import { TradeSplitPanelColumnDefs, tradeSplitPanelGridOptions } from './TradeSplitPanelGridModel'
import { Locale, Translation } from 'locale'
import { createOrganisationMetaDetailSelector } from 'selectors/organisationSelectors'

export type ViewTradeSplitPanelProps = OwnProps & StateProps

interface OwnProps extends ModalConsumerProps {
  organisationId: string
}

interface StateProps {
  organisationMetaDetails: OrganisationMetaDetail[]
}

interface DispatchProps {}

const organisationIdSelector = (_state: {}, ownProps: ViewTradeSplitPanelProps) => ownProps.organisationId

const mapStateToProps = createStructuredSelector({
  organisationMetaDetails: createOrganisationMetaDetailSelector(organisationIdSelector)
})

const Wrapper = styled(Groupbox)`
  height: 450px;
`

export const ViewTradeSplitPanelComponent: React.FunctionComponent<ViewTradeSplitPanelProps> = props => {
  const { organisationMetaDetails } = props

  const noTradeSplitsPlaceholder = () => <div>{Locale.translate(Translation.SC_NO_TRADE_SPLITS)}</div>

  return (
    <Wrapper>
      <AgGridWrapper
        className="datagrid-borderless"
        gridOptions={tradeSplitPanelGridOptions}
        columnDefs={TradeSplitPanelColumnDefs}
        rowData={organisationMetaDetails}
        placeholder={noTradeSplitsPlaceholder}
      />
    </Wrapper>
  )
}

export const ViewTradeSplitPanel = withModal(connect<StateProps, DispatchProps, OwnProps>(mapStateToProps)(ViewTradeSplitPanelComponent))
